import React from "react";
import { Button } from "react-bootstrap";
import { CSVLink } from "react-csv";
import cx from "classnames";

import Toast from 'src/components/toast';

import { prepareRequest } from "../../services/report.service"

import styles from "./styles.module.scss";
import _ from "lodash";
import { toast } from "react-toastify";
import { localizedStrings } from "../../../localization"

class Download extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      id: this.props.id,
      request: this.props.request,
      fileName: this.props.fileName,
      headers: this.props.headers,
      pagination: this.props.pagination,
      downloaded: this.props.downloaded,
      downloading: this.props.downloading,
      downloadedPercentage: 0,
      error: this.props.error,
      data: this.props.data,
    };

    this.handleDownload = this.handleDownload.bind(this);
    this.getFileName = this.getFileName.bind(this);
    this.getHeaders = this.getHeaders.bind(this);
    this.handleProcessRequest = this.handleProcessRequest.bind(this);

    this.localizedKeywords = localizedStrings.keywords;
    this.localizedCommons = localizedStrings.commons;
    this.localizedCommonActions = this.localizedCommons.actions;
    this.localizedReport = localizedStrings.pages.reports;
    this.localizedSettings = localizedStrings.pages.settings;
    this.localizedNda = this.localizedSettings.templates.nda;
    this.localizedSliders = this.localizedSettings.templates.nda.sliders;
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      id: nextProps.id,
      fileName: nextProps.fileName,
      headers: nextProps.headers,
      pagination: nextProps.pagination,
      downloaded: nextProps.downloaded,
      error: nextProps.error,
      data: nextProps.data,
      request: nextProps.request
    });

    if (this.state.downloading && nextProps.pagination && !nextProps.error) {
      let totalPages = nextProps.pagination.totalPages;
      let nextPage = nextProps.pagination.currentPage + 1;

      if (nextPage < totalPages) {
        this.handleDownload(nextPage, nextProps.pagination.recordsPerPage);
      }

      if (nextProps.pagination.currentPage > 0) {
        let totalRecordsCount = nextProps.pagination.totalRecordsCount;
        let downloadedRecordsCount = nextProps.data.length;

        var percentage = Math.floor(
          (downloadedRecordsCount / totalRecordsCount) * 100
        );

        this.setState({
          downloadedPercentage: percentage,
        });
      }

      if (nextProps.downloaded) {
        this.setState({ downloading: false, downloadedPercentage: 0 });
        setTimeout(() => {
          this.csvLink.link.click();
          this.resetReportDownloadState();

          toast(
            <Toast.Sucess
              toast={toast}
              heading = {this.localizedSliders.toast.heading}
              message ={this.localizedNda.actions.download_reports_success}            
            />,
            {
              autoClose: 3000,
            }
          );
        }, 1000);
      }
    }

    if (nextProps.error && this.state.downloading) {

      this.setState({ downloading: false, downloadedPercentage: 0 });
      this.resetReportDownloadState();

      toast(
        <Toast.Failure
        message = {this.localizedNda.actions.download_reports_failure}
      /> , {
        autoClose: 3000,
    })
    }
  }

  resetReportDownloadState() {
    this.props.resetReportDownload();
  }

  handleDownload(page, limit) {
    if (_.get(this.state.request, "reportFilter", false) || _.get(this.state.request, "reportDate", false)) {
      this.handleProcessRequest(page, limit);
    } else {
      this.props.fetchData(this.state.id, this.state.request, page, limit);
    }
  }

  getFileName() {
    let fileName = "Reports.csv";
    if (this.state.fileName) {
      fileName = this.state.fileName + Date.now() + ".csv";
    }

    return fileName;
  }

  getHeaders() {
    let headers = [];
    if (this.state.headers) {
      headers = this.state.headers;
    }

    return headers;
  }

  handleProcessRequest(page, limit) {
    const processedRequest = prepareRequest(
      this.state.request,
      this.props.supportedEntities
    );

    if (!_.isEqual(this.state.request, processedRequest)) {
      this.setState(
        {
          request: processedRequest,
        },
        () => {
          this.props.fetchData(this.state.id, this.state.request, page, limit);
        }
      );
    }
  }

  render() {
    return (
      <div className={cx(styles.download)}>

        <button
          className={cx(styles.button, this.props.className)}
          disabled={this.state.downloading}
          onClick={() => {
            this.setState({ downloading: true, downloadedPercentage: 0 });
            this.handleDownload(0, this.state.pagination.recordsPerPage);
          }}>

          <span  onClick={this.handleViewMoreClicked}>
            <i className="paperflite-download" /> {this.state.downloading
            ? `${this.localizedCommonActions.downloading} ${this.state.downloadedPercentage}%`
            : this.localizedCommonActions.download}
          </span>

        </button>


        <CSVLink
          filename={this.getFileName()}
          headers={this.getHeaders()}
          data={this.state.data}
          ref={(csvLink) => (this.csvLink = csvLink)}
        />
      </div>
    );
  }
}

export default Download;
